import { render, staticRenderFns } from "./ApprovalTab.vue?vue&type=template&id=4d70b809&"
import script from "./ApprovalTab.vue?vue&type=script&lang=js&"
export * from "./ApprovalTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports